import { BaseInputProps } from "../types/componentTypes";

interface TextInputProps extends BaseInputProps {};

const TextInput: React.FC<TextInputProps> = ({
  label,
  disabled,
  required,
  error,
  ...props
}) => {
  return (
    <div className="max-w-lg">
      {label && (
        <label
          htmlFor={props.name}
          className="block text-sm text-black mb-1 font-bold"
        >
          {label}
        </label>
      )}
      <div className="relative">
        <input
          type="text"
          id={props.name}
          {...props}
          disabled={disabled}
          required={required}
          className={`input w-full py-2 px-3 border rounded-lg bg-gray-100 truncate overflow-hidden whitespace-nowrap`}
        />
        {error && <div className="text-red-500 text-xs mt-1">{error}</div>}
      </div>
    </div>
  );
};

export default TextInput;
